import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, input, viewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { MaterialModule } from '../../material.module';
import { FormatBytesPipe } from '../../pipes/format-bytes.pipe';

const ALLOWED_IMAGE_TYPES: readonly string[] = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
];

@Component({
  selector: 'app-image-upload-base64',
  imports: [CommonModule, FormatBytesPipe, MaterialModule, TranslateModule],
  templateUrl: './image-upload-base64.component.html',
  styleUrls: ['./image-upload-base64.component.scss'],
})
export class ImageUploadBase64Component {
  translate = inject(TranslateService);

  readonly fileInput = viewChild<ElementRef<HTMLInputElement>>('fileInput');

  readonly controller = input.required<FormControl>();
  readonly limit = input(1024 * 1024); // 1MB
  readonly stylingOptions = input({
    fullWidth: false,
    noBackground: false,
    reverseButtons: false,
  });
  readonly uploadButtonText = input<string>(undefined);

  handleUpload(file: File) {
    this.controller().setValue(null);
    this.controller().markAsTouched();

    if (!file) return;

    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      this.controller().setErrors({ type: true });
      return;
    } else {
      this.controller().setErrors(null);
    }

    if (file.size > this.limit()) {
      this.controller().setErrors({ size: true });
      return;
    } else {
      this.controller().setErrors(null);
    }

    if (this.controller().invalid) {
      this.fileInput().nativeElement.value = null;
      return;
    }

    const reader = new FileReader();

    reader.onload = () => this.controller().setValue(reader.result as string);

    reader.readAsDataURL(file);
  }

  removeFile() {
    this.controller().setValue(null);
    this.controller().setErrors(null);
    this.fileInput().nativeElement.value = null;
  }
}
